module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/dfb8f8fae0ee6d0f38c2c832c53c2d28.png";